import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "";

const STATUS_BADGE = {
  active:   { bg: "#166534", color: "#4ade80", label: "ACTIVE" },
  upcoming: { bg: "#3b2f0e", color: "#fbbf24", label: "UPCOMING" },
  finished: { bg: "#1e3a5f", color: "#60a5fa", label: "FINISHED" },
};

export default function Seasons() {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/seasons`)
      .then(r => setSeasons(r.data.seasons || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1>🏆 Seasons & Leagues</h1>

      {loading ? (
        <div className="card" style={{ textAlign: "center", padding: "2rem", color: "#9ca3af" }}>Loading...</div>
      ) : seasons.length === 0 ? (
        <div className="card" style={{ textAlign: "center", padding: "3rem", color: "#9ca3af" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🏆</div>
          <div style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}>No seasons yet</div>
          <div style={{ fontSize: "0.85rem" }}>Create one via the API to get started</div>
          <pre style={{ marginTop: "1rem", background: "#13151f", padding: "1rem", borderRadius: "6px", fontSize: "0.8rem", textAlign: "left", display: "inline-block" }}>
{`curl -X POST http://localhost:4000/api/seasons \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_ADMIN_TOKEN" \\
  -d '{"name": "Season 1", "description": "First season"}'`}
          </pre>
        </div>
      ) : (
        <div style={{ display: "grid", gap: "1rem" }}>
          {seasons.map(s => {
            const badge = STATUS_BADGE[s.status] || STATUS_BADGE.upcoming;
            return (
              <Link key={s.id} to={`/seasons/${s.id}`} style={{ textDecoration: "none" }}>
                <div className="card" style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                  borderLeft: `4px solid ${badge.color}`, transition: "border-color 0.2s" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.3rem" }}>
                      <span style={{ fontWeight: "700", fontSize: "1.15rem", color: "#f3f4f6" }}>{s.name}</span>
                      <span style={{ background: badge.bg, color: badge.color, padding: "0.15rem 0.5rem",
                        borderRadius: "4px", fontSize: "0.7rem", fontWeight: "700" }}>{badge.label}</span>
                    </div>
                    {s.description && <div style={{ color: "#9ca3af", fontSize: "0.85rem" }}>{s.description}</div>}
                    <div style={{ color: "#6b7280", fontSize: "0.8rem", marginTop: "0.3rem" }}>
                      {s.match_count} matches
                      {s.started_at && ` · Started ${new Date(s.started_at).toLocaleDateString()}`}
                      {s.finished_at && ` · Ended ${new Date(s.finished_at).toLocaleDateString()}`}
                    </div>
                  </div>
                  <span style={{ color: "#5865f2", fontSize: "1.2rem" }}>→</span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
